<template>
  <div class="rail-wrapper" ref="rail">
    <!-- EVENT RAIL HEADER -->

    <SectionHeader
      :see-all-path="seeAllPath"
      class="mx-1"
      style="margin-bottom: 10px"
      :title="sectionHeaderTitle"
      :title-lg="titleLg"
      :has-border-top="titleHasBorderTop"
    ></SectionHeader>

    <div
      v-if="isCardLoading"
      style="min-height: 140px; width: 100%; overflow:hidden; position: relative"
    >
      <b-loading animation :is-full-page="false" :active.sync="isCardLoading" :can-cancel="false"></b-loading>
    </div>

    <div class="event-rail">
      <!-- EVENT CARD -->
      <div
        itemscope
        itemtype="http://schema.org/Event"
        class="event-card no-highlight"
        v-for="event in events.filter(e => e.id !== eventId)"
        :key="event.id"
      >
        <!-- IMAGE -->
        <div class="event-card__img">
          <router-link
            @click.native="$analytics.logEvent('view_item', { page_name: $route.name, item_name: event.data.eventName, item_id: event.id, button_name: 'event_img_on_card_rail'})"
            :to="{name: 'event-view', params: {eventID: event.id, eventPreview: event}}"
          >
            <!-- @click.native="$store.commit('appData/SET_DISPLAYED_EVENT', event)" -->
            <figure class="image">
              <img
                itemprop="image"
                v-if="event.data.eventImagePaths.posterURLs"
                class="is-lazy"
                lazy="loaded"
                v-lazy="event.data.eventImagePaths.posterURLs[1]"
                :alt="event.data.eventName"
              />
            </figure>
          </router-link>
          <StarBtn
            :star-color="'rgba(255,255,255,0.6)'"
            style="position: absolute; top: 8px; right: 4px"
            :event="event"
          ></StarBtn>
        </div>
        <!-- ./IMAGE -->

        <!-- EVENT CARD CONTENT -->
        <div class="event-card__content">
          <!-- EVENT NAME -->
          <router-link
            class="no-highlight mt-half"
            style=" margin-bottom: 0px"
            :to="{name: 'event-view', params: {eventID: event.id, eventPreview: event}}"
            @click.native="$analytics.logEvent('view_item', { page_name: $route.name, item_name: event.data.eventName, item_id: event.id, button_name: 'event_title_on_card_rail'})"
          >
            <h4
              itemprop="name"
              class="has-text-black-bis mb-0 cursor-link has-text-weight-medium is-size-15px has-ellipsis"
            >{{ event.data.eventName }}</h4>
          </router-link>

          <!-- EVENT DATETIME -->
          <CardDatetime
            class="is-size-13px"
            style="line-height: 1.7;"
            :on-poster="true"
            :show-type="showType"
            :event-showtimes="event.data.eventShowtimes"
            :show-extra-dates="false"
          ></CardDatetime>

          <!-- EVENT Venue -->
          <CardVenue
            class="has-ellipsis is-size-13px"
            style="line-height: 1.4;"
            :show-venue-logo="false"
            :show-venue="showVenue"
            :event-venue-name="event.data.eventVenueName"
            :event-venue-id="event.data.eventVenueID"
            :event-venue-avatar-url="event.data.eventVenueAvatarURL"
            :event-venue-rich-address="event.data.eventVenueRichAddress"
          ></CardVenue>

          <!-- EVENT PRICE -->
          <!-- <CardPrice  style="font-size:14px" :event-ticket-info="event.data.eventTicketInfo" :event-id="event.id"></CardPrice> -->
        </div>
        <!-- ./EVENT CARD CONTENT -->
      </div>

      <div class="event-card-end-gap"></div>

      <!-- ./EVENT CARD -->
    </div>
  </div>
</template>

<script>
import { ticketPriceMixin } from "@/mixins/ticket";
import CardDatetime from "@/components/shared/CardDatetime";
import SectionHeader from "@/components/shared/SectionHeader";
import CardVenue from "@/components/shared/CardVenue";

import StarBtn from "@/components/shared/StarBtn";
// import CardPrice from "@/components/shared/CardPrice";

export default {
  props: {
    routeName: {
      type: String,
      default: ""
    },
    eventType: {
      type: String,
      default: ""
    },
    venueId: {
      type: String,
      default: ""
    },
    eventId: {
      type: String,
      default: ""
    },
    orderLimit: {
      type: Number,
      default: 6
    },
    railHeader: {
      type: String
    },
    seeAllPath: {
      type: String,
      default: ""
    },
    showType: {
      type: Boolean,
      default: false
    },
    subtitle: {
      type: String,
      default: ""
    },
    showPrice: {
      type: Boolean,
      default: false
    },
    showVenue: {
      type: Boolean,
      default: true
    },
    showSubType: {
      type: Boolean,
      default: false
    },
    titleLg: {
      type: Boolean,
      default: false
    },
    sectionHeaderTitle: {
      type: String,
      default: ""
    },
    titleHasBorderTop: {
      type: Boolean,
      default: true
    }
    // cardIsMedium: {
  },
  components: { CardDatetime, SectionHeader, CardVenue, StarBtn },
  data() {
    return {
      events: [],
      isCardLoading: false
    };
  },

  created() {
    if (this.routeName !== this.$route.name) return;

    this.isCardLoading = true;

    this.fetchEvents();
  },
  methods: {
    async fetchEvents() {
      if (process.env.NODE_ENV === "development") {
        // console.log("there is evnet type", this.eventType);
      }
      // console.log('fetch events');

      if (this.venueId) {
        try {
          this.events = await this.$store.dispatch(
            "appData/fetchEventsByVenueID",
            {
              venueID: this.venueId,
              orderLimit: this.orderLimit
            }
          );

          const eventCount =
            this.events.filter(e => e.id !== this.eventId).length > 0;

          this.$emit("event-count", eventCount);
        } catch (error) {
          if (process.env.NODE_ENV === "development") {
            console.error(error);
          }
        }
      } else if (this.eventType.length) {
        try {
          this.events = await this.$store.dispatch(
            "appData/fetchEventsByType",
            {
              eventType: this.eventType,
              orderLimit: this.orderLimit
            }
          );
        } catch (error) {
          if (process.env.NODE_ENV === "development") {
            console.error(error);
          }
        }
      }

      // console.log('RAIL EVENTS', this.events, this.eventType);

      // if no events remove rail
      if (!this.events.length) {
        this.$refs.rail.style.display = "none";
      } else {
        this.$emit("is-loaded", true);
      }

      this.isCardLoading = false;
    },
    eventSubtypesJoined(subtypes) {
      let joined = "";
      for (let i = 0; i < subtypes.length; i++) {
        joined += this.$options.filters.capitalize(
          this.$t(`evType.${subtypes[i]}`)
        );
        if (i !== subtypes.length - 1) joined += ", ";
      }
      return joined;
    },
    logHitCategoryMenuItem(val) {
      this.$analytics.logEvent("view_item_list", {
        item_name: val,
        page_name: this.$route.name
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.event-header {
  padding: 0 1rem;
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-end;
}

.event-header .title {
  margin-bottom: 0 !important;
}

$card-width: 35vw;
// $card-max-width: 110px;
$card-min-width: 110px;
$card-width-lg-device: 16vw;

$breakpoint-lg: 980px;

.event-card {
  width: $card-width;
  @media screen and (min-width: $breakpoint-lg) {
    width: $card-width-lg-device;
  }
  display: inline-block;
  margin: 0 5px;
}
.event-card:first-child {
  margin-left: 1rem;
}
.event-card-end-gap {
  min-width: 8px;
  min-height: 100%;
}

.event-card__img figure {
  border-radius: 2px;
  overflow: hidden;
  width: $card-width;
  height: $card-width * 1.4;
  min-height: $card-width * 1.4;
  max-height: $card-width * 1.4;
  @media screen and (min-width: $breakpoint-lg) {
    width: $card-width-lg-device;
    min-height: $card-width-lg-device * 1.4;
    max-height: $card-width-lg-device * 1.4;
  }
  -webkit-box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
  -moz-box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
  // height: $card-width;
}

.event-card img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.event-card__content {
  padding-top: 8px;
}
.event-card__content h4 {
  // margin-bottom: 2px;
  line-height: 1.3;
  white-space: pre-wrap;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.card-row {
  font-size: 14px;
  color: $grey-darker;
}
.card-row .image {
  background-color: $grey-light;
}

.event-rail {
  display: flex;
  padding: 0 0.75rem 0 0;
  /* Make this scrollable when needed */
  overflow-x: auto;
  /* We don't want vertical scrolling */
  overflow-y: hidden;
  /* Make an auto-hiding scroller for the 3 people using a IE */
  -ms-overflow-style: -ms-autohiding-scrollbar;
  /* For WebKit implementations, provide inertia scrolling */
  -webkit-overflow-scrolling: touch;
  /* We don't want internal inline elements to wrap */
  white-space: nowrap;
  /* Remove the default scrollbar for WebKit implementations */
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>